import { render } from "./custom-table.vue?vue&type=template&id=6dedfddd&lang=html"
import script from "./custom-table.vue?vue&type=script&lang=js"
export * from "./custom-table.vue?vue&type=script&lang=js"

import "./custom-table.vue?vue&type=style&index=0&id=6dedfddd&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__